module.exports = __webpack_public_path__ + "img/logoWhiteFull.26762322.png";